import type { FC } from 'react';
import { Tooltip } from 'antd';
import startCase from 'lodash/startCase';
import upperCase from 'lodash/upperCase';
import type { CalendarEvent, Frequency } from '../../../types/calendar';
import CalendarInterval from './CalendarInterval';

export interface PeriodCellProps {
    events: CalendarEvent[];
    frequency: Frequency;
    pxPerDay: number;
    periodStartDate: string;
    cellWidth: number;
}

const PeriodCell: FC<PeriodCellProps> = ({ events, frequency, pxPerDay, periodStartDate, cellWidth }) => {
    let marginLeftSpacing = 0;
    if (frequency === 'W') {
        marginLeftSpacing = cellWidth / 7;
    }
    if (frequency === 'M') {
        marginLeftSpacing = pxPerDay;
    }

    return (
        <>
            <CalendarInterval
                frequency={frequency}
                periodStartDate={periodStartDate}
                cellWidth={cellWidth}
                pxPerDay={pxPerDay}
            />
            <div className="items-center flex">
                {events?.map((evt) => (
                    <Tooltip
                        key={`${periodStartDate}-${evt.label}-${evt.startDay}`}
                        title={`${evt.label} | ${upperCase(evt.promoType) || 'N/A'} | ${Math.round(evt.durationDays / 7)} weeks`}
                    >
                        <div
                            className="absolute z-[1] h-8 border-l-2 flex items-center overflow-hidden text-xs font-normal rounded-tr-[0.25rem] rounded-br-[0.25rem] pointer-events-auto cursor-pointer"
                            style={{
                                marginLeft: evt.startDay * marginLeftSpacing,
                                width: evt.durationDays * marginLeftSpacing,
                                backgroundColor: evt.bgColor,
                                borderColor: evt.color,
                                color: evt.color,
                            }}
                        >
                            <div className="ml-2 min-w-0">
                                <p className="truncate">{`${startCase(evt.promoType)} | ${Math.round(evt.durationDays / 7)} weeks`}</p>
                            </div>
                        </div>
                    </Tooltip>
                ))}
            </div>
        </>
    );
};

PeriodCell.displayName = 'PeriodCell';
export default PeriodCell;
